module.exports = __webpack_public_path__ + "media/images/flags/ad-7b784da9dd0c41e55a419ad0a7e99330.svg";